module.exports = __webpack_public_path__ + "img/java_light_grey_ba_detail_rsh0.caac8ed6.jpg";